import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import '@arco-design/web-react/dist/css/arco.css';

// 添加 polyfill
if (!Object.hasOwn) {
  Object.hasOwn = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
